"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var uuid_1 = require("uuid");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var AddNewDeliveryAddress_1 = require("components/OrderAndDistributionComponents/AddNewDeliveryAddress");
var AddRecipients_1 = require("components/OrderAndDistributionComponents/AddRecipients");
var AddressBook_1 = require("components/OrderAndDistributionComponents/AddressBook");
var DistributionRecipients_1 = require("components/OrderAndDistributionComponents/DistributionRecipients");
var functions_1 = require("components/OrderAndDistributionComponents/helpers/functions");
var noRecipientIcon = '/assets/sokopro_mario_icon.svg';
var quantities = (0, functions_1.getQuantitiesList)();
function getFirstItemId(list) {
    if (list.length > 0 && list[0]) {
        return list[0].id;
    }
    return -1;
}
var distributionRecipients = function (props) {
    var recipients = Object.values(props.wizard.distributionRecipients);
    return recipients;
};
var component = function (props) {
    var recipients = distributionRecipients(props);
    return (React.createElement("div", { className: 'sok-distribution-wizard-step2' }, props.wizard.step2.display === 'LIST' ? (React.createElement("div", null,
        React.createElement("div", { className: 'disclaimer' },
            React.createElement("div", null, (0, translation_1.getLocalization)('userfront/distributionwizard/step2/info'))),
        React.createElement("div", { className: 'button-row' },
            React.createElement(sok_ui_1.Button, { size: 'large', color: 'base-green', text: (0, translation_1.getLocalization)('userfront/distribution/edit/step1/add'), onClick: props.changeStep2View('ADD') })),
        recipients.length > 0 ? (React.createElement("div", { className: 'container' },
            React.createElement("div", { className: 'header' },
                React.createElement("h3", null, (0, translation_1.getLocalization)('userfront/distribution/list'))),
            React.createElement(DistributionRecipients_1.default, __assign({}, props, { quantities: quantities, distributionRecipients: recipients, mode: 'EDIT', type: 'DISTRIBUTION', errors: props.wizard.errors, allowedPrintProviders: (props.currentProject &&
                    props.currentProject.printProvider && [
                    props.currentProject.printProvider
                ]) ||
                    [] })))) : (React.createElement("div", { className: 'no-recipients-message' },
            React.createElement("img", { src: noRecipientIcon }),
            React.createElement("div", null,
                React.createElement("b", null, (0, translation_1.getLocalization)('userfront/distribution/step2/thereAreNo')),
                React.createElement("span", null,
                    (0, translation_1.getLocalization)('userfront/distribution/step2/use'),
                    ' ',
                    React.createElement("i", null, (0, translation_1.getLocalization)('userfront/distributionwizard/step2/add')),
                    ' ',
                    (0, translation_1.getLocalization)('userfront/distribution/step2/toAttach'))))))) : (React.createElement("div", null,
        React.createElement("div", { className: 'disclaimer' },
            React.createElement("div", null, (0, translation_1.getLocalization)('userfront/distribution/disclaimer'))),
        props.wizard.step2.addNewDeliveryAddress && (React.createElement("div", { className: 'container add-new-delivery-address-form' },
            React.createElement("div", { className: 'header' },
                React.createElement("h3", null, (0, translation_1.getLocalization)('userfront/distribution/newDeliveryAddress'))),
            React.createElement("div", { className: 'container' },
                React.createElement(AddNewDeliveryAddress_1.default, __assign({ addNewRecipient: props.newExternalUser }, props))))),
        React.createElement("div", { className: 'container' },
            React.createElement("h3", null, (0, translation_1.getLocalization)('userfront/distribution/recipients')),
            props.wizard.step2.tab === 0 ? (React.createElement("div", { className: 'add-recipients-tools' },
                React.createElement(sok_ui_1.Button, { size: 'large', color: 'base-green', onClick: function () {
                        var users = props.recipients.list.status === 'FETCHED'
                            ? props.recipients.list.users.filter(function (row) {
                                return props.recipients.selected.lastIndexOf(row.id) > -1;
                            })
                            : [];
                        props.addDistributionRecipient(users.map(function (u) { return ({
                            uuid: (0, uuid_1.v4)(),
                            user: u,
                            quantity: 1,
                            finishing: getFirstItemId(props.finishings.list),
                            deliveryMethod: -1,
                            printProvider: getFirstItemId(props.printProviders.list),
                            excluded: false
                        }); }), props.recipients.selected)();
                    }, disabled: !props.recipients.selected.length, text: (0, translation_1.getLocalization)('userfront/distribution/step2/addSelected') }),
                React.createElement(sok_ui_1.Button, { size: 'large', onClick: props.backToList(props), color: 'dark-gray', text: (0, translation_1.getLocalization)('userfront/button/cancel') }))) : (React.createElement("div", { className: 'address-book-tools' },
                React.createElement(sok_ui_1.Button, { size: 'large', color: 'blue', onClick: props.changeStep2AddNewDeliveryAddress(true), text: (0, translation_1.getLocalization)('userfront/distribution/edit/step1/addNew') }),
                React.createElement(sok_ui_1.Button, { size: 'large', color: 'green', onClick: function () {
                        var users = props.addressBook.list.status === 'FETCHED'
                            ? props.addressBook.list.users.filter(function (row) {
                                return props.addressBook.selected.lastIndexOf(row.id) >
                                    -1;
                            })
                            : [];
                        props.addDistributionRecipient(users.map(function (u) { return ({
                            uuid: (0, uuid_1.v4)(),
                            user: u,
                            quantity: 1,
                            finishing: getFirstItemId(props.finishings.list),
                            deliveryMethod: -1,
                            printProvider: getFirstItemId(props.printProviders.list),
                            excluded: false
                        }); }), props.addressBook.selected)();
                    }, disabled: !props.addressBook.selected.length, text: (0, translation_1.getLocalization)('userfront/distribution/edit/step1/addFrom') }),
                React.createElement(sok_ui_1.Button, { size: 'large', onClick: props.backToList(props), color: 'dark-gray', text: (0, translation_1.getLocalization)('userfront/button/cancel') }))),
            React.createElement(sok_ui_1.Tabs, { className: 'sok-distribution-wizard-tabsbar', activeIndex: props.wizard.step2.tab, onClick: props.changeStep2Tab },
                React.createElement("span", null, (0, translation_1.getLocalization)('userfront/distribution/recipients')),
                React.createElement("span", null, (0, translation_1.getLocalization)('userfront/distribution/addressBook')),
                React.createElement(AddRecipients_1.default, __assign({}, props)),
                React.createElement(AddressBook_1.default, __assign({}, props))))))));
};
exports.default = component;
